import React from 'react';

/** Conteneur de contenu : fond, bordure fine, pas d'ombre lourde. */
export const Card = ({ children, className = '', ...props }) => (
  <div className={`rounded-card border border-line bg-surface shadow-card ${className}`} {...props}>
    {children}
  </div>
);

export const CardHeader = ({ children, className = '' }) => (
  <div className={`flex flex-wrap items-center justify-between gap-3 border-b border-line px-4 py-3 ${className}`}>
    {children}
  </div>
);

export const CardTitle = ({ children, className = '' }) => (
  <h2 className={`text-sm font-semibold text-ink ${className}`}>{children}</h2>
);

export const CardContent = ({ children, className = '' }) => (
  <div className={`px-4 py-4 ${className}`}>{children}</div>
);

export const CardFooter = ({ children, className = '' }) => (
  <div className={`flex flex-wrap items-center justify-between gap-3 border-t border-line px-4 py-3 ${className}`}>
    {children}
  </div>
);

export default Card;
